"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { capture, resumePostHogCapturing, silencePostHogForExcludedPath } from "@/lib/analytics";
import { trackGaEvent, updateGoogleConsent } from "@/lib/gtag";
import { currentPrivacyChoices, PRIVACY_CHANGED, PRIVACY_STORAGE_KEY } from "@/lib/privacyChoices";

/** Synchronize choices across navigation and tabs without reloading a form. */
export function PrivacyRuntime() {
  const pathname = usePathname();
  useEffect(() => { updateGoogleConsent(); }, [pathname]);
  useEffect(() => {
    let previous = currentPrivacyChoices();
    function apply() {
      const next = currentPrivacyChoices();
      updateGoogleConsent();
      if (next.analytics) {
        resumePostHogCapturing();
        if (!previous.analytics) {
          trackGaEvent("page_view", { page_path: window.location.pathname, page_location: window.location.href, page_title: document.title });
          capture("$pageview");
        }
      } else silencePostHogForExcludedPath();
      previous = next;
    }
    function onStorage(event: StorageEvent) { if (event.key === PRIVACY_STORAGE_KEY || event.key === null) apply(); }
    window.addEventListener(PRIVACY_CHANGED, apply);
    window.addEventListener("storage", onStorage);
    return () => { window.removeEventListener(PRIVACY_CHANGED, apply); window.removeEventListener("storage", onStorage); };
  }, []);
  return null;
}
